export default function Contact() {
	return <section id="contact">
		<h1>Contact Us</h1>
		<p>Interested in having us for your next event or becoming a partner? Send us an e-mail to <a href="mailto:business@l33t.studio">business@l33t.studio</a> with all the details.</p>
	</section>
}
